import TWEEN from '@tweenjs/tween.js'

const animate = () => {
  requestAnimationFrame(animate)

  TWEEN.update()
}

animate()
